import React, { useState } from 'react';
import { DatePicker, Space } from 'antd';
import { DESIGN_CONFIG, STRING_CONFIG } from 'utils';
import { useMedia } from 'helpers';
import moment from 'moment';
import { Calendar } from 'lucide-react';

function DatePickerInput({ setUser }) {
  const smallDevice = useMedia('(max-width:450px)');
  const [isFocused, setIsFocused] = useState(false);

  const disableInvalidDates = (current) => {
    if (!current) return false;

    const today = moment().endOf('day');
    const minDate = moment().subtract(18, 'years').startOf('day');
    return current > today || current > minDate;
  };

  const handleDateChange = (date, dateString) => {
    setUser((prevUser) => ({
      ...prevUser,
      dateOfBirth: date ? dateString : '',
    }));
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <DatePicker
        disabledDate={disableInvalidDates}
        defaultPickerValue={moment().subtract(18, 'years')}
        format="YYYY/MM/DD"
        onBlur={() => setIsFocused(false)}
        onChange={handleDateChange}
        onFocus={() => setIsFocused(true)}
        placeholder={STRING_CONFIG.inPage.userProfile.plHDateOfBirth}
        style={{
          border: isFocused
            ? `1px solid ${DESIGN_CONFIG.color.primary.primaryMain}`
            : `1px solid ${DESIGN_CONFIG.color.neutral.neutral100}`,
          borderRadius: '4px',
          boxShadow: 'none',
          height: '2.25rem',
          width: `${smallDevice ? '100%' : '12.5rem'}`,
        }}
        suffixIcon={
          <Calendar
            size={18}
            color={DESIGN_CONFIG.color.text.text200}
          />
        }
      />
    </Space>
  );
}

export default DatePickerInput;